import { AggregateType, DateRangeType } from "../../../common/enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../../common/enums/NumericalFunctionEnum";
import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { ColumnType, EventColumnEnum, OptionalColumnEnum, TimeframeType } from "../../enums/DRCXEnums";
import { makeEventColumnEquatableKey } from "./MakeEventColumnEquatableKey";
import { makeOptionalColumnEquatableKey } from "./MakeOptionalColumnEquatableKey";
import { makeTatColumnEquatableKey } from "./MakeTatColumnEquatableKey";
import { makeTatTypeColumnEquatableKey } from "./MakeTatTypeColumnEquatableKey";

export function makeColumnEquatableKey(
    columnType: ColumnType | undefined,
    optionalColumn: OptionalColumnEnum | undefined,
    key: string | undefined,
    tagAssociationTypeID: number | undefined,
    tatTypeID: number | undefined,
    dataType: DataTypeEnum | undefined,
    groupingTimeframe: TimeframeType | undefined,
    groupingFunction: NumericalFunctionEnum | undefined,
    aggregationType: AggregateType | undefined,
    aggregationPeriod: number | undefined,
    aggregationFunction: NumericalFunctionEnum | undefined,
    aggregationStepDateRange: DateRangeType | undefined,
    aggregationStep: number | undefined,
    eventColumn: EventColumnEnum | undefined,
    id: number | undefined
): string {
    return columnType === ColumnType.Optional
        ? makeOptionalColumnEquatableKey(
            optionalColumn as OptionalColumnEnum,
            key as string,
            id)
        : columnType === ColumnType.Tat
            ? makeTatColumnEquatableKey(
                tagAssociationTypeID as number,
                dataType ?? DataTypeEnum.Double,
                groupingTimeframe as TimeframeType,
                groupingFunction,
                aggregationType,
                aggregationPeriod,
                aggregationFunction,
                aggregationStepDateRange,
                aggregationStep
            )
            : columnType === ColumnType.TatType
                ? makeTatTypeColumnEquatableKey(
                    tatTypeID as number,
                    dataType ?? DataTypeEnum.Double,
                    groupingTimeframe as TimeframeType,
                    groupingFunction,
                    aggregationType,
                    aggregationPeriod,
                    aggregationFunction,
                    aggregationStepDateRange,
                    aggregationStep
                )
                : columnType === ColumnType.Event
                    ? makeEventColumnEquatableKey(eventColumn as EventColumnEnum)
                    : "INVALID";
}
